//lightbox
import { LuminousGallery } from "luminous-lightbox";

var luminousOpts4 = {
  caption: (trigger) => {
    return trigger.querySelector("img").getAttribute("alt");
  },
};

var luminousGalleryElems2 = document.querySelectorAll(".luminous");

if (luminousGalleryElems2.length > 0) {
  new LuminousGallery(luminousGalleryElems2, {}, luminousOpts4);
}
